import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogLayoutComponent, BlogMetadata } from './blog-layout.component';

@Component({
  selector: 'app-whatsapp-chatbot-blog',
  standalone: true,
  imports: [CommonModule, BlogLayoutComponent],
  template: `
    <app-blog-layout [metadata]="blogMetadata">
      <div class="blog-content-markdown">
        <p>Hoy en día, <strong>WhatsApp</strong> es más que una app de mensajería: es el canal favorito de millones de personas para contactar con negocios. Por eso, <strong>automatizar las conversaciones con un chatbot</strong> se ha convertido en una estrategia clave para vender más y atender mejor.</p>

        <hr>

        <h2>🤖 ¿Qué es un chatbot para WhatsApp?</h2>
        <p>Un <strong>chatbot</strong> es un asistente virtual que responde mensajes de forma automática en tiempo real. Cuando se integra con <strong>WhatsApp Business API</strong>, el chatbot puede:</p>

        <ul>
          <li>Responder preguntas frecuentes.</li>
          <li>Enviar catálogos, cotizaciones o links de pago.</li>
          <li>Recoger datos de clientes.</li>
          <li>Guiar al usuario durante el proceso de compra.</li>
        </ul>

        <hr>

        <h2>📈 ¿Cómo te ayuda a vender más?</h2>
        <h3>1. Atención 24/7</h3>
        <p>No pierdes oportunidades fuera del horario laboral. El bot atiende incluso fines de semana.</p>

        <h3>2. Respuestas inmediatas</h3>
        <p>El cliente recibe atención en segundos, sin esperar.</p>

        <h3>3. Ventas guiadas</h3>
        <p>El chatbot puede cotizar, generar órdenes o dar seguimiento.</p>

        <h3>4. Segmentación</h3>
        <p>Identifica si es cliente nuevo, frecuente, o si ya compró antes.</p>

        <h3>5. Menor carga operativa</h3>
        <p>Tu equipo se enfoca en tareas clave mientras el bot responde lo repetitivo.</p>

        <hr>

        <h2>📊 Caso real</h2>
        <div class="case-study-card">
          <p>Una empresa del sector retail implementó un chatbot en WhatsApp para responder dudas sobre productos y pedidos. Antes, una persona respondía 80 mensajes diarios manualmente. Ahora, el bot atiende más del 90% y el equipo solo interviene en casos complejos.</p>

          <div class="case-study-metrics">
            <div class="metric">
              <span class="metric-value">20h</span>
              <span class="metric-label">ahorradas por semana</span>
            </div>
            <div class="metric">
              <span class="metric-value">+35%</span>
              <span class="metric-label">ventas por WhatsApp</span>
            </div>
            <div class="metric">
              <span class="metric-value">3</span>
              <span class="metric-label">meses de ROI</span>
            </div>
          </div>
        </div>

        <hr>

        <h2>🧰 ¿Qué necesitas para tener un chatbot?</h2>
        <ol>
          <li>Una cuenta de <strong>WhatsApp Business API</strong>.</li>
          <li>Número verificado por Meta.</li>
          <li>Flujos de conversación definidos.</li>
          <li>Integración opcional con CRM o tienda online.</li>
        </ol>

        <p>¿Y si ya usas WhatsApp Business desde el celular? Esa versión no permite bots avanzados. Para escalar, necesitas la API oficial, y nosotros te ayudamos a configurarla.</p>

        <hr>

        <h2>📞 ¿Quieres vender más por WhatsApp?</h2>
        <p>En <strong>Pezeta Solutions</strong> ayudamos a PyMEs mexicanas a integrar chatbots inteligentes para WhatsApp que venden 24/7.</p>
        <p><strong>Solicita una consultoría gratuita</strong> y descubre cómo automatizar tus ventas.</p>
      </div>
    </app-blog-layout>
  `,
  styles: [`
    .blog-content-markdown {
  line-height: 1.7;
  color: var(--text-color);
}

.blog-content-markdown h2,
.blog-content-markdown h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.blog-content-markdown ul,
.blog-content-markdown ol {
  padding-left: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.blog-content-markdown p {
  text-align: justify;
}


    .case-study-card {
      background: var(--light-gray);
      padding: 2rem;
      border-radius: 12px;
      margin: 2rem 0;
      border-left: 4px solid var(--primary-color);
    }

    .case-study-metrics {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      gap: 1.5rem;
      margin-top: 1.5rem;
    }

    .metric {
      text-align: center;
      background: var(--white);
      padding: 1rem;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    .metric-value {
      display: block;
      font-size: 2rem;
      font-weight: 700;
      color: var(--primary-color);
      margin-bottom: 0.25rem;
    }

    .metric-label {
      font-size: 0.875rem;
      color: #666;
      font-weight: 500;
    }
  `]
})
export class WhatsAppChatbotBlogComponent {
  blogMetadata: BlogMetadata = {
    title: '¿Qué es un chatbot para WhatsApp y cómo puede ayudarte a vender más?',
    description: 'Descubre cómo un chatbot para WhatsApp puede ayudarte a automatizar ventas, atender clientes 24/7 y aumentar tu conversión. Ideal para PyMEs mexicanas.',
    author: 'Pezeta Solutions',
    publishDate: '2025-06-21',
    readTime: '7 min',
    keywords: 'chatbot WhatsApp México, automatización ventas WhatsApp, atención cliente WhatsApp, Pezeta Solutions chatbot, PyME chatbot WhatsApp',
    image: 'images/chatbot-whatsapp-para-vender-mas.webp',
    slug: 'chatbot-whatsapp-para-vender-mas',
    category: 'Automatización'
  };
}
